<svg
	width="1em"
	height="1em"
	viewBox="0 0 24 24"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	xml:space="preserve"
	fill-rule="evenodd"
	clip-rule="evenodd"
	stroke-linecap="round"
	stroke-linejoin="round"
>
	<g transform="matrix(1.17105,0,0,1.17105,-2.05262,-2.05262)">
		<path d="M6,9L12,15L18,9" style="fill:none;fill-rule:nonzero;stroke:currentColor;stroke-width:1.67px;" />
	</g>
</svg>
